/**
 * token管理
 */
import { useUserStore } from '@/stores/index.js';
import { ElMessageBox } from 'element-plus';

// 定义token
const KEY_TOKEN = 'tb_web_token';
const USER_INFO = 'tb_user_info';

function isLogin() {
  try {
    return !!JSON.parse(localStorage.getItem(KEY_TOKEN))?.accessToken;
  } catch (e) {
    console.error(e);

    return false;
  }
}

function getToken() {
  try {
    return JSON.parse(localStorage.getItem(KEY_TOKEN));
  } catch (e) {
    console.error(e);

    return {};
  }
}

function setToken(val) {
  try {
    localStorage.setItem(KEY_TOKEN, JSON.stringify(val));
  } catch (e) {
    console.error(e);
  }
}

function clearToken() {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(USER_INFO);

  // 全局变量
  const userStore = useUserStore();

  // 全局变量重置
  userStore.storeReset();
}

function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem(USER_INFO));
  } catch (e) {
    console.error(e);

    return {};
  }
}

function setUserInfo(val) {
  try {
    localStorage.setItem(USER_INFO, JSON.stringify(val));
  } catch (e) {
    console.error(e);
  }
}

/**
 * 是否登录
 * @returns {boolean} 是否登录
 */
function isLoginMessage() {
  if (!isLogin()) {
    ElMessageBox.confirm('请登录后，继续操作！', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      window.location.href = `/login?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
    });

    return false;
  } else {
    return true;
  }
}

/**
 * 是否实名认证
 * @returns {boolean} 是否实名认证
 */
function isRealName() {
  if (!getUserInfo()?.idNumber) {
    ElMessageBox.confirm('当前未进行实名认证,请实名后继续操作！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      window.location.href = '/user/user-my-info/my-account-authentication';
    });

    return false;
  } else {
    return true;
  }
}

/**
 * 是否职员认证
 * @param {string} [roleType] 职员类型 如：'1、2、3'（非必填）
 * @returns {boolean} 是否职员认证
 */
function isRoleAuth(roleType) {
  const roleAuthType = getUserInfo()?.roleAuthInfo?.roleAuthType;

  if (!roleAuthType) {
    ElMessageBox.confirm('当前未进行职员认证,请职员认证后继续操作！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      window.location.href = '/user/user-my-info/my-account-authentication';
    });

    return false;
  } else {
    if (roleType) {
      if (roleType.includes(roleAuthType)) {
        return true;
      } else {
        // 全局变量
        const userStore = useUserStore();

        const types = userStore.role_auth_type.filter((e) => {
          if (roleType.includes(e.value)) {
            return e;
          }

          return null;
        });

        ElMessageBox.confirm(`仅限 ${types.map(e => e.label).join('、')} 角色参与活动！`, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
        });

        return false;
      }
    } else {
      return true;
    }
  }
}

/**
 * 是否企业认证
 */
function isCompanyAuth() {
  if (!getUserInfo()?.enterpriseAuthed) {
    ElMessageBox.confirm('当前未进行企业认证,请企业认证后继续操作！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      window.location.href = '/user/user-my-info/my-account-authentication';
    });

    return false;
  } else {
    return true;
  }
}

/**
 * 是否讲师认证
 */
function isLecturerAuthed() {
  if (!getUserInfo()?.isLecturerAuthed) {
    ElMessageBox.confirm('当前未进行讲师认证,请讲师认证后继续操作！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      window.location.href = '/user/user-my-info/my-role-authentication';
    });

    return false;
  } else {
    return true;
  }
}

export {
  clearToken,
  getToken,
  getUserInfo,
  isCompanyAuth,
  isLecturerAuthed,
  isLogin,
  isLoginMessage,
  isRealName,
  isRoleAuth,
  setToken,
  setUserInfo,
};
